import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-privacy-ecoach',
  templateUrl: './privacy-ecoach.component.html',
  styleUrls: ['./privacy-ecoach.component.scss'],
})
export class PrivacyEcoachComponent {
  // Icons
  faArrowLeft = faArrowLeft;

  language: 'de' | 'en';

  // Authentication status
  public isAuthenticated$: Observable<boolean>;

  constructor(
    private router: Router,
    private translateService: TranslateService,
    private store: Store<{ isAuthenticated: boolean }>,
    private activatedRoute: ActivatedRoute,
  ) {
    this.isAuthenticated$ = this.store.select('isAuthenticated');
    const storedLanguage = localStorage.getItem('language');
    this.language = storedLanguage === 'de' ? 'de' : 'en';
    localStorage.setItem('language', this.language);
    this.translateService.use(this.language);
    this.activatedRoute.queryParams.subscribe(
      (params) => this.changeLanguage(params.locale),
    );
  }

  private changeLanguage(paramLanguage: string) {
    if (!paramLanguage || paramLanguage === this.language) {
      return;
    }
    const languages = ['ca', 'de', 'en', 'es', 'fr', 'ro'];
    if (languages.includes(paramLanguage)) {
      this.language = paramLanguage === 'de' ? 'de' : 'en';
      localStorage.setItem('language', this.language);
      this.translateService.use(this.language);
    }
  }

  public redirectToLogin(): void {
    this.router.navigate(['/login']);
  }
}
